import { useCan } from '@/hooks/useAbility';

export function useCanUseAi(): boolean {
  return useCan('create', 'AiThread');
}
